import axios, { AxiosError, AxiosInstance } from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api/v1';

const superAdminApiClient: AxiosInstance = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
  timeout: 30000,
});

superAdminApiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('superAdminAccessToken');

    if (!config.headers) {
      config.headers = {} as any;
    }

    if (token) {
      (config.headers as any).Authorization = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

superAdminApiClient.interceptors.response.use(
  (response) => response,
  async (error: AxiosError) => {
    const originalRequest: any = error.config;

    if (error.response?.status === 401 && !originalRequest?._retry) {
      originalRequest._retry = true;

      try {
        const refreshToken = localStorage.getItem('superAdminRefreshToken');
        if (refreshToken) {
          const response = await axios.post(`${API_BASE_URL}/super-admin/auth/refresh`, {
            refreshToken,
          });

          const accessToken = response.data?.data?.accessToken;
          const nextRefreshToken = response.data?.data?.refreshToken;
          if (accessToken) {
            localStorage.setItem('superAdminAccessToken', accessToken);
            if (nextRefreshToken) {
              localStorage.setItem('superAdminRefreshToken', nextRefreshToken);
            }
            originalRequest.headers = originalRequest.headers || {};
            originalRequest.headers.Authorization = `Bearer ${accessToken}`;
            return superAdminApiClient(originalRequest);
          }
        }
      } catch (refreshError) {
        localStorage.removeItem('superAdminAccessToken');
        localStorage.removeItem('superAdminRefreshToken');
        localStorage.removeItem('superAdminUser');
        window.location.href = '/super-admin/login';
        return Promise.reject(refreshError);
      }
    }

    return Promise.reject(error);
  }
);

export default superAdminApiClient;
